import {
  SET_CALCULATING,
  SET_CALCULATING_TOPIC,
  SET_CALCULATING_CATEGORY,
  SET_CALCULATING_COUNTRY,
  SET_CALCULATION_STATUS,
  SET_CALCULATION_LIST,
  DELETE_CALCULATION,
  SET_CALCULATION_DEFAULT_API_DATA
} from '../actions/action';

import calculationModel from '../models/calculation';

import {
  validateNumberInterval,
  // parseOrder
} from '../tools/tools';

/*
  calculatingCountry:[(String)country name, (String)base64;data flag img ]
*/

const initialState = {
  calculating: calculationModel(),
  calculatingCountry:[],
  calculationStatus:'',
  calculationList:[]
}


export default (state = initialState, action) => {
  const { type, template, topic, index, index1, prop, countryData, status, calcList, id, apiData } = action;
  let { value } = action;

  // validating topic
  if(topic) {
    topic.relevance=validateNumberInterval(topic.relevance);
    topic.score=validateNumberInterval(topic.score,[1,10]);
  }

  if(prop === 'relevance') {
    value=validateNumberInterval(value);
  }

  const {calculating}=state;

  if (type === SET_CALCULATING) {
    return { ...state, calculating: calculationModel(template) }


  } else if(type === SET_CALCULATING_TOPIC) {
    const newCats=calculating.categories.map((elem,catIndex)=>{
      if(index === catIndex) {
        elem.topics=elem.topics.map((elem,topicIndex)=>{
          if(topicIndex === index1) {
            elem=topic;
          }
          return {...elem}
        });
      }
      return {...elem}
    });

    const newCalculating=calculationModel({...calculating,categories:newCats});
    newCalculating.calculation();

    return {...state,calculating:newCalculating}


  } else if(type === SET_CALCULATING_CATEGORY) {
    const newCats=calculating.categories.map((cat,catIndex)=>{
      if(catIndex === index) {
        cat[prop]=value;
      }
      return {...cat};
    });

    const newCalculating=calculationModel({...calculating,categories:newCats});
    newCalculating.calculation();
    
    return {...state,calculating:newCalculating}

    
  } else if(type === SET_CALCULATION_DEFAULT_API_DATA) {
    const newCalculating=calculationModel({...calculating,defaultApiData:apiData});
    return {...state,calculating:newCalculating}
    

  } else if(type === SET_CALCULATING_COUNTRY) {
    return {...state,calculatingCountry:countryData}


  } else if(type === DELETE_CALCULATION) {
    const newCalcs=state.calculationList.filter(elem=>elem._id!==id);
    return {...state,calculationList:newCalcs,calculationStatus:''}

  } else if(type === SET_CALCULATION_STATUS) {
    return {...state,calculationStatus: status}


  } else if(type === SET_CALCULATION_LIST) {
    const list=calcList.map(elem=>{
      const calc=calculationModel(elem);
      calc.calculation();
      return calc;
    });
    return {...state, calculationList: list, calculationStatus: ''}
  }

  return state;
}